<template >
    <div class="main-container" v-if="['execBudgetList', 'forzenBudgetList'].includes($route.name)">
        <div class="flex">
            <div>
                <h2 class="main-title" >预算{{ queryParams.execType == 1? '执行' : '冻结' }}数据</h2>
            </div>
            <el-button class="back-btn" type="text" @click="goBack">
                <i name="back" scale="2" class="el-icon-arrow-left"></i>
                返回</el-button>
        </div>
        <div class="horizon-line "></div>
        <div class="company-main" v-loading="loading">
            <el-form label-width="120px" class="search-form">
                <el-row :gutter="24">
                <el-col :span="8">
                    <el-form-item label="一级部门">
                        <el-select disabled filterable clearable v-model="queryParams.firstDeptId" placeholder="请选择一级部门">
                            <el-option v-for="item in firstDeptList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="年份">
                        <el-select disabled :clearable="false" @change="setBudgetCycleByYear" v-model="queryParams.budgetYear" placeholder="请选择年份">
                            <el-option v-for="item in yearList" :key="item.year" :label="item" :value="item"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="预算周期">
                        <el-date-picker disabled type="monthrange" :clearable="false"
                        v-model="queryParams.budgetCycle"
                        :picker-options="pickerOptions" format="yyyy-MM" value-format="yyyyMM" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="预算大类">
                        <el-select disabled v-model="queryParams.typeId" filterable clearable placeholder="请选择预算大类"
                            class="mid-el-width" @change="setChildTypeList">
                            <el-option v-for="item in budgetTypeList" :key="item.dicId" :label="item.dicName"
                                :value="item.dicId"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="预算类型">
                        <el-select v-model="queryParams.childTypeId" :disabled="true || !queryParams.typeId" filterable clearable placeholder="请选择预算类型"
                            class="mid-el-width">
                            <el-option v-for="item in childTypeList" :key="item.dicId" :label="item.dicName"
                                :value="item.dicId"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="业务单号">
                        <el-input v-model.trim="queryParams.sourceNum" clearable placeholder="请填写业务单号"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="24" class="search-btn">
                    <el-button type="primary" @click="refresh">查询</el-button>
                    <el-button type="primary" @click="resetAll">重置</el-button>
                </el-col>
                </el-row>
            </el-form>
            <!-- <div class="mb-12">
                <el-upload class="inline-block" 
                    action="" :limit="150"
                    :show-file-list="false"
                    :file-list="uploadFileList"
                    :http-request="handleUpload"
                    :on-progress="()=>{loading=true}" 
                    :on-error="()=>{loading=false}">
                    <el-button
                        :disabled="loading"
                        size="mini"
                        type="primary"
                        ><i class="el-icon-upload"></i> 导入执行数据
                    </el-button>
                </el-upload>
                <el-button size="mini" type="primary">导入执行数据</el-button>
                <el-button class="ml-10" size="mini" @click="downloadTemplateExecl" >点击下载模板</el-button>
                <el-button size="mini" @click="exportList" type="primary">导出列表数据</el-button>
            </div> -->
            <div class="tips mb-12">已{{queryParams.execType == 1 ? '执行' : '冻结' }}金额合计：{{ totalExecRmb | currency}}</div>
            <common-table :tableColumnData="columns" :data="tableData">
            </common-table>
            <pager
                @currentchange="changePage"
                @sizechange="changeSize"
                v-model.trim="pageDto">
            </pager>
        </div>
    </div>
</template>
<script>
import { defineComponent, ref, reactive, onMounted, getCurrentInstance } from 'vue'
import { awaitWrapper, sleep, exportExecl } from "@/common/utils/assist.js";
import { currency } from "@/common/utils/assist.js";

import { FORZEN_LIST, EXEC_LIST } from './config'
import { usePageDto } from '@/common/mixins/usePageDto'
import minus from "library/functions/minus";

import {
    queryYearList, // 获取审批过的编制申请年度数据
    getOperationAetail,
    getOriTree, // 传7 获取预算大类
    getAdjustFirstDeptList,
    downloadTemplate,
    uploadExecl, // 导入执行数据
    exportMonthDetailList, // 导出预算明细列表
    getOperationAetailTotal,
} from './request'

export default defineComponent({
    filters: {
        currency
    },
    setup(props, context) {
        const { proxy } = getCurrentInstance()
        const loading = ref(false)
        const queryParams = reactive({
            childTypeId: null,
            firstDeptId: null,
            typeId: null,
            yearMonthStart: null,
            yearMonthEnd: null,
            budgetCycle: [],
            year: null,
            month: null,
            execType: null, // type1是执行。2是冻结
            sourceNum: null, // 业务单号
        })
        const tableData = ref([])
        const childTypeList = ref([]) // 预算类型
        const budgetTypeList = ref([]) // 预算大类
        const firstDeptList = ref([]) // 一级部门
        const columns = ref(FORZEN_LIST)
        const cycleTime = ref([])
        const totalExecRmb = ref(0)
        const fetchList = async () => {
            // setStartAndEndMonth()
            const params = {
                pageDto: {
                    pageNum: pageDto.pageNum,
                    pageSize: pageDto.pageSize,
                },
                year: queryParams.year,
                month: queryParams.month,
                firstLevelId: queryParams.firstDeptId,
                subjectsCatId: queryParams.typeId,
                subjectsTypeId: queryParams.childTypeId,
                type: queryParams.execType,
                sourceNum: queryParams.sourceNum
            }
            loading.value = true
            const [, res] = await awaitWrapper(getOperationAetail(params))
            loading.value = false
            console.log('res', res)
            if (res && res.code == 0) {
                const queryInfo = proxy.$route.query
                tableData.value = (res.data || []).map(item=>{
                    return {
                        ...item,
                        firstDeptName: queryInfo.firstDeptName,
                        type: queryInfo.subjectsCatName,
                        childType: queryInfo.subjectsTypeName,
                        budgetYear: queryInfo.year,
                        budgetCycleYear: queryInfo.budgetCycleYear,
                        budgetYearMonth: item.year + '年' + item.month +'月',
                        operationPrice: [1, 4].includes(item.operationFlag) ? minus(0, item.operationPrice) : item.operationPrice
                    }
                })
                pageDto.count = res.pageDto.count || 0
                // console.log("pageDto", pageDto)
            }
            const totalParams = {
                year: queryParams.year,
                month: queryParams.month,
                firstLevelId: queryParams.firstDeptId,
                subjectsCatId: queryParams.typeId,
                subjectsTypeId: queryParams.childTypeId,
                type: queryParams.execType,
                sourceNum: queryParams.sourceNum
            }
            const [, totalRes] = await awaitWrapper(getOperationAetailTotal(totalParams))
            if (totalRes && totalRes.code === 0) {
                totalExecRmb.value = totalRes.data || 0
            } else {
                totalExecRmb.value = 0
            }
        }

        const { pageDto, refresh, changePage, changeSize } = usePageDto(fetchList)

        const resetAll = () => {
            // queryParams.yearMonthStart = null
            // queryParams.yearMonthEnd = null
            // queryParams.childTypeId = null
            // queryParams.firstDeptId = null
            // queryParams.typeId = null
            // queryParams.year = null
            // queryParams.budgetCycle = []
            queryParams.sourceNum = null
            // setDefaultYear()
            pageDto.pageNum = 1
            refresh()
        }
        const setStartAndEndMonth = () => { // 设置起止月份
            if (queryParams.budgetCycle.length > 0) {
                queryParams.yearMonthStart = queryParams.budgetCycle[0]
                queryParams.yearMonthEnd = queryParams.budgetCycle[1]
            }
        }
        
        const setBudgetCycleByYear = () => { // 根据年份设置预算周期
            // 获取当前选择的年份
            const selectedYear = queryParams.year;
            // 如果未选择年份，不执行任何操作
            if (!selectedYear) {
                return;
            }
            const yearNumber = selectedYear.slice(0, 4);
            // 检查是否包含"自然年"字段
            if (selectedYear.includes('自然年')) {
                // 提取年份数字
                // 设置为自然年周期 [XXXX01, XXXX12]
                queryParams.budgetCycle = [`${yearNumber}01`, `${yearNumber}12`]
                // queryParams.yearMonthStart = `${yearNumber}01`
                // queryParams.yearMonthEnd = `${yearNumber}12`
            } else {
                // 设置为财年周期 [(XXXX-1)08, XXXX07]
                const previousYear = yearNumber - 1;
                queryParams.budgetCycle = [`${previousYear}08`, `${yearNumber}07`]

                // queryParams.yearMonthStart = `${previousYear}08`
                // queryParams.yearMonthEnd = `${yearNumber}07`
            }
            cycleTime.value = [queryParams.budgetCycle[0], queryParams.budgetCycle[1]]
            setStartAndEndMonth()
        }
        

        const yearList = ref([])
        const getYearList = async () => { // 
            loading.value = true
            let [, res] = await awaitWrapper(queryYearList())
            loading.value = false
            if (res && res.code == 0) {
                yearList.value = res.data || []
                // setDefaultYear()
            }
        }
        const setDefaultYear = () => {
            let sortedYearList = (yearList.value || []).map(item=>{
                return {
                initName: item,
                year: parseInt(item.slice(0, 4))
                }
            }).sort((a, b)=> {
                if (b.year !== a.year) {
                    return b.year - a.year; // 降序，最新年份排在前面
                }
                if (b.initName.includes('自然年')) {
                    return 1; // b含自然年，b排在前面
                } else if (a.initName.includes('自然年')) {
                    return -1; // a含自然年，a排在前面
                }
                return 0;
            })
            
            // console.log('const setDefaultYear sortedYearList', sortedYearList)
            if (sortedYearList.length > 0) {
                queryParams.year = sortedYearList[0].initName
                setBudgetCycleByYear()
            }
        }

        const queryEhrFirstDepts = async () => {
            loading.value = true
            let [, res] = await awaitWrapper(getAdjustFirstDeptList())
            loading.value = false
            firstDeptList.value = (res.data || []).map(item => {
                return {
                    ...item,
                    dicId: item.id,
                    dicName: item.name,
                    ehrFirstId: item.id
                }
            })
        }

        const setChildTypeList = () => {
            childTypeList.value = null
            // queryParams.childTypeId = null
            const filterBudgetType = budgetTypeList.value.filter(item => {
                return item.dicId == queryParams.typeId
            })
            if (Array.isArray(filterBudgetType) && filterBudgetType.length > 0) {
                childTypeList.value = filterBudgetType[0].childrens || []
            } else {
                childTypeList.value = []
            }
        }
        const getOriInfo = async (type) => {
            loading.value = true
            let [, res] = await awaitWrapper(getOriTree({
                dataType: type
            }))
            loading.value = false
            if (!res || res.code != 0) {
                return
            }
            if (type == 7) {
                budgetTypeList.value = res.data.tree || []
            }
            setChildTypeList()
        }

        // 设置日期选择器可选择的日期范围
        const pickerOptions = ref({})
        const setPickerOptions = () => {
            pickerOptions.value = {
                disabledDate(time) {
                    // 获取当前日期的年月格式字符串（yyyyMM）
                    const date = new Date(time);
                    const timeFormat = date.getFullYear() + 
                                    (date.getMonth() + 1).toString().padStart(2, '0');
                    // 限制可选日期范围
                    return timeFormat < cycleTime.value[0] || timeFormat > cycleTime.value[1];
                },
            }
        }
        setPickerOptions()
        onMounted(async () => {
            const queryInfo = proxy.$route.query
            queryParams.childTypeId = Number(queryInfo.subjectsTypeId)
            queryParams.firstDeptId = Number(queryInfo.firstLevelId)
            queryParams.typeId = Number(queryInfo.subjectsCatId)
            queryParams.yearMonthStart = queryInfo.month
            queryParams.yearMonthEnd = queryInfo.month
            queryParams.budgetCycle = [queryInfo.year + '' + queryInfo.month, queryInfo.year + '' + queryInfo.month]
            queryParams.year = queryInfo.year
            queryParams.budgetYear = queryInfo.budgetYear
            queryParams.month = queryInfo.month
            queryParams.execType = queryInfo.execType
            console.log('queryParams', queryParams)
            if (queryInfo.execType == 1) {
                columns.value = EXEC_LIST
            }
            getYearList()
            queryEhrFirstDepts()
            getOriInfo(7)
            fetchList()
        })

        // 根据
        const downloadTemplateExecl = async () => {
            const [, res] = await awaitWrapper(downloadTemplate({
                id: 5
            }))
            if (res) {
                exportExecl(res, '线下执行明细批量导入模板')
            }
        }
        const uploadFileList = ref([])

        // 上传导入执行数据
        const handleUpload = async (upload) => {
            let formParams = new FormData();
            formParams.append("file", upload.file); // 文件
            console.log('uploadExecl upload.file', upload.file)
            const [, res] = await awaitWrapper(uploadExecl(formParams))
            try {
                const uint8_msg = new Uint8Array(res)
                let encodedString = String.fromCharCode.apply(null, uint8_msg)
                let decodedString = decodeURIComponent(escape(encodedString))
                const jsonData = JSON.parse(decodedString)
                if (jsonData.code === 0 || jsonData.code === '0') {
                    // context.$message.success('导入成功')
                } else {
                    // toast(jsonData.msg)
                }
            } catch (error) {
                context.$message.warning('导入文件存在错误，请在浏览器下载列表中打开《导入错误列表》')
                exportExecl(res, '导入错误列表')
            }
        }

        const exportList = async() => {
            setStartAndEndMonth()
            const params = {
                pageNum: 0,
                pageSize: 0,
                childTypeId: queryParams.childTypeId,
                firstDeptId: queryParams.firstDeptId,
                typeId: queryParams.typeId,
                yearMonthStart: queryParams.yearMonthStart,
                yearMonthEnd: queryParams.yearMonthEnd,
            }
            loading.value = true
            const [, res] = await awaitWrapper(exportMonthDetailList(params))
            loading.value = false
            // console.log('res', res)
            try {
                if (res) {
                    exportExecl(res, '', true)
                }
            } catch (error) {
                console.log('error', error)
            }
        }

        const goBack = () => {
            proxy.$router.go(-1)
        }
        
        return {
            // 查询相关
            columns,
            loading,
            queryParams,
            pageDto,
            tableData,
            refresh,
            changePage,
            changeSize,
            resetAll,
            // 查询条件
            yearList,
            budgetTypeList,
            childTypeList,
            firstDeptList,
            uploadFileList,

            setBudgetCycleByYear,
            setChildTypeList, // 设置预算大类下的预算类型
            pickerOptions,
            downloadTemplateExecl, // 下载模板
            handleUpload,
            exportList,
            goBack,
            totalExecRmb, // 已执行/冻结金额
            fetchList
        }
    },
})
</script>
<style lang="scss" scoped>
.inline-block {
    display: inline-block;
}
.ml-10 {
    margin-left: 10px;
}
.mb-12 {
    margin-bottom: 12px;
}
.company-main {
  padding: 24px;
}
.search-form {
  width: 100%;
}
.search-btn {
  text-align: right;
}
.left-btn {
    margin-bottom: 12px;
}
/* .container {
    position: relative;
} */
.flex {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.tips {
    font-size: 14px;
    color: #606266;
}
.mb-12 {
    margin-bottom: 12px;
}
.search-btn {
  text-align: right;
}
.el-row {
    display: flex;
    flex-wrap: wrap;
}
</style>